// extracted by mini-css-extract-plugin
module.exports = {"metrics":"Metrics-module--metrics--1cdLN","contract":"Metrics-module--contract--z7siI"};